import * as MuiModal from '@mui/material/Modal'
import React from 'react'

export type ModalProps = MuiModal.ModalProps

export function Modal({ children, ...props }: ModalProps) {
  return <MuiModal.default {...props}>{children}</MuiModal.default>
}
